module.exports = __webpack_public_path__ + "img/collapse.22be5209.svg";